<!--
 * @Author: ext.shuiqianning1
 * @Date: 2022-04-24 12:12:50
 * @LastEditors: ext.shuiqianning1
 * @LastEditTime: 2022-06-06 10:02:28
 * @FilePath: /content-center/src/components/radio/payment.vue
-->
<template>
  <div class="content-item flex">
    <div class="content-item-label"><span class="red" v-if="JSON.parse(commonData[0].value)==='1'">*</span>付费情况</div>
    <el-radio-group v-model="radio" class="flex align-items-center">
      <el-radio :label="1">自费</el-radio>
      <el-radio :label="2">免费</el-radio>
      <el-radio :label="3">依据当地防疫情况而定</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  name: "payment",
  props: ['value', 'commonData'],
  computed: {
    radio: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('update:value',val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
